<template>
  <div class="main__content">
    <div class="table__header_bar">
      <InputSearch isFilter @detectSearchValue="searchTableHandler" />
    </div>
    <Table
      v-if="!!getTableOfVotingHistoryDart"
      :content="getTableData"
      @tableHandler="tableHandler"
    />
    <v-skeleton-loader v-else type="table" />
  </div>
</template>

<script>
import Table from '@/elements/Table';
import { mapGetters } from 'vuex';

export default {
  components: { Table },

  data() {
    return {};
  },

  async created() {
    this.$store.dispatch('getTableOfVotingHistoryDart');
  },

  computed: {
    ...mapGetters(['getTableOfVotingHistoryDart']),

    getTableData() {
      return this.getTableOfVotingHistoryDart?.table?.items;
    },
  },

  methods: {
    tableHandler() {
      this.$store.dispatch('getTableOfVotingHistoryDart');
    },

    searchTableHandler(val) {
      this.$store.commit('SET_TABLE_SORT_DATA', { search: val });
      this.$store.dispatch('getTableOfVotingHistoryDart');
    },
  },
};
</script>
